// Sprung aus dem Artikel-Slot in den Lister-Reiter des OTTO-Verkaufskanals.
//
// Der Lister ist eine Integration an `settings.sales-channels.{appId}.tabs` (id `otto-lister`). Die
// Tab-Leiste gehört VARIO, deshalb wechselt der Host per `openInSameTab` mit der echten ERP-Route
// (in der Gambio-App am 2026-09-15 aus `additionalPayload` abgelesen):
//   { name: 'saleschannels.saleschannel.app', params: { channelType, id, appIdentifier, integrationId } }
// Der generierte Name `apps.<appIdentifier>.<integrationId>` wurde dort ohne Kanal-Parameter ignoriert.
//
// `channelType` und `id` stehen auf der iframe-URL des Listers (VARIO hängt alle Parameter der
// aktuellen ERP-Route an). Der Lister merkt sie sich deshalb beim Öffnen. Bis dahin gilt der Kanal
// aus der Installation mit dem Typ, mit dem die App Kanäle anlegt (MARKETPLACE).

export const LISTER_INTEGRATION_ID = 'otto-lister';
export const LISTER_ROUTE_KEY = 'otto.listerRoute';
export const FOCUS_KEY = 'otto.focus';
const DEFAULT_CHANNEL_TYPE = 'MARKETPLACE';

export interface ListerChannel { channelType: string; id: string }
export interface VarioRouteTarget { name: string; params: Record<string, string> }

/** Kanal-Parameter aus der iframe-URL des Listers, `null` außerhalb des Verkaufskanals. */
export function listerChannelFromSearch(search: string): ListerChannel | null {
  const q = new URLSearchParams(search);
  const channelType = q.get('channelType');
  const id = q.get('id');
  return channelType && id ? { channelType, id } : null;
}

/** Ziel-Route für `openInSameTab`. Gemerkter Kanal gewinnt, sonst Installationskanal. */
export function buildListerRouteTarget(
  search: string,
  remembered: ListerChannel | null,
  installChannelId: string | null,
): VarioRouteTarget | null {
  const appIdentifier = new URLSearchParams(search).get('appIdentifier');
  if (!appIdentifier) return null;
  const channel = remembered && (!installChannelId || remembered.id === installChannelId)
    ? remembered
    : (installChannelId ? { channelType: DEFAULT_CHANNEL_TYPE, id: installChannelId } : null);
  if (!channel) return null;
  return {
    name: 'saleschannels.saleschannel.app',
    params: { channelType: channel.channelType, id: channel.id, appIdentifier, integrationId: LISTER_INTEGRATION_ID },
  };
}

export function readRememberedListerChannel(): ListerChannel | null {
  try {
    const raw = localStorage.getItem(LISTER_ROUTE_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as Partial<ListerChannel>;
    return typeof p.channelType === 'string' && typeof p.id === 'string' ? { channelType: p.channelType, id: p.id } : null;
  } catch {
    return null;
  }
}

export function rememberListerChannel(search: string): void {
  const ch = listerChannelFromSearch(search);
  if (!ch) return;
  try { localStorage.setItem(LISTER_ROUTE_KEY, JSON.stringify(ch)); } catch { /* ohne Speicher gilt der Rückfall */ }
}
